import PropTypes from 'prop-types';
import { CONTRACT_DOCUMENT_TYPES } from 'constants/digitalLoanPhase4';
import Button from 'components/UI/Button';

const ContractReadyScreen = ({
  literals,
  documentError = '',
  openingTipo = '',
  onOpenDocument,
  onHome,
}) => (
  <div className='full-screen-container digital-loan-preoffer'>
    <div className='screen-content digital-loan-preoffer__scroll'>
      <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
      <p className='digital-loan-phase2__body mb-2'>{literals.body}</p>
      <p className='digital-loan-phase2__body mb-4'>{literals.depositLater}</p>
      <h2 className='digital-loan-summary-block__title'>{literals.documentsTitle}</h2>
      {CONTRACT_DOCUMENT_TYPES.map((document) => (
        <div className='mb-3' key={document.tipo}>
          <Button
            text={literals.documents[document.literalKey]}
            type='secondary'
            loading={openingTipo === document.tipo}
            disabled={Boolean(openingTipo)}
            onClick={() => onOpenDocument(document.tipo)}
          />
        </div>
      ))}
      {documentError && (
        <p className='digital-loan-phase2__body' role='alert'>{documentError}</p>
      )}
    </div>
    <div className='screen-actions'>
      <Button text={literals.home} onClick={onHome} />
    </div>
  </div>
);

ContractReadyScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  documentError: PropTypes.string,
  openingTipo: PropTypes.string,
  onOpenDocument: PropTypes.func.isRequired,
  onHome: PropTypes.func.isRequired,
};

export default ContractReadyScreen;
